export const findPipelineForCard = (
  pipelines = [],
  selectedPipeline = null,
  pipelineId = null
) => {
  const matchingPipeline = pipelines.find(
    pipeline => String(pipeline.id) === String(pipelineId)
  );
  if (matchingPipeline) return matchingPipeline;

  if (
    selectedPipeline &&
    (pipelineId == null || String(selectedPipeline.id) === String(pipelineId))
  ) {
    return selectedPipeline;
  }

  return null;
};

export const orderedStagesForPipeline = pipeline => {
  return Object.entries(pipeline?.stages || {})
    .map(([id, stage]) => {
      let terminalType = null;
      if (stage.is_won_stage === true) terminalType = 'won';
      if (stage.is_lost_stage === true) terminalType = 'lost';

      return {
        id,
        ...stage,
        position: stage.position ?? 0,
        terminalType,
        terminal: stage.terminal === true || terminalType !== null,
      };
    })
    .sort((a, b) => a.position - b.position);
};

export const resolveCardStageName = (
  card,
  pipelines = [],
  selectedPipeline = null
) => {
  const stageId = card?.pipeline_stage;
  if (!stageId) return '-';

  const pipeline = findPipelineForCard(
    pipelines,
    selectedPipeline,
    card?.pipeline_id
  );
  return pipeline?.stages?.[stageId]?.name || stageId;
};
